import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { PollResult, PollResultsState } from './types'

const initialState: PollResultsState = {
  polls: [],
  isLoading: false,
  error: null,
  expandedKeys: [],
}

const fetchRequestHandler = (state: PollResultsState) => {
  state.isLoading = true
  state.error = null
}

const fetchSuccessHandler = (state: PollResultsState, { payload }: PayloadAction<PollResult[]>) => {
  state.isLoading = false
  state.polls = payload
}

const fetchFailureHandler = (state: PollResultsState, { payload }: PayloadAction<string>) => {
  state.isLoading = false
  state.error = payload
}

const toggleVotersHandler = (state: PollResultsState, { payload }: PayloadAction<string>) => {
  state.expandedKeys = state.expandedKeys.includes(payload)
    ? state.expandedKeys.filter(pollKey => pollKey !== payload)
    : [...state.expandedKeys, payload]
}

const slice = createSlice({
  name: 'communicationBoardPollResults',
  initialState,
  reducers: {
    fetchRequest: fetchRequestHandler,
    fetchSuccess: fetchSuccessHandler,
    fetchFailure: fetchFailureHandler,
    toggleVoters: toggleVotersHandler,
  },
})

export const { fetchRequest, fetchSuccess, fetchFailure, toggleVoters } = slice.actions

export default slice.reducer
